const availableLocales = ["de", "en"];

/** Returns the current locale if translations are available for it and defaults to "en" otherwise */
export const getLocaleFromAvailable: () => (typeof availableLocales)[number] =
  () => {
    const locale = navigator.language.split("-")[0].toLowerCase();
    if (availableLocales.includes(locale)) return locale;
    return "en";
  };
